module.exports = __webpack_public_path__ + "img/BAWS_Sword5_3_2.49b4ffbf.png";